import type { Option } from '../lib/categories';

type Props = {
  label: string;
  required?: boolean;
  options: Option[];
  // Selected option values (0..N). The category field is MULTI_SELECT in Twenty.
  value: string[];
  onChange: (next: string[]) => void;
};

// Multi-select category control rendered as toggle chips. Mirrors the
// MULTI_SELECT category field on Company/Person: 0..N values, order-insensitive.
export const CategoryPicker = ({
  label,
  required,
  options,
  value,
  onChange,
}: Props) => {
  const toggle = (optionValue: string) => {
    onChange(
      value.includes(optionValue)
        ? value.filter((v) => v !== optionValue)
        : [...value, optionValue],
    );
  };

  return (
    <div className="picker">
      <span className="picker-label">
        {label}
        {required && <span className="req"> *</span>}
      </span>
      <div className="chips">
        {options.map((option) => {
          const on = value.includes(option.value);
          return (
            <button
              key={option.value}
              type="button"
              className={`chip-toggle${on ? ' on' : ''}`}
              aria-pressed={on}
              onClick={() => toggle(option.value)}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};
